import type { Issue, User } from "./types";
import { relevantHomeTasks } from "./workspaceHome";
import { humanOwnerId } from "./taskOwnership";

export const CURRENT_ONBOARDING_VERSION = 1;

export interface OnboardingEligibility {
  hydrated: boolean;
  initialSlug?: string;
  workspaceSlug?: string;
  activeView: string;
  currentUserId: string;
  currentUser?: User;
  onboardingVersion: number;
  hasEntityDeepLink: boolean;
}

/**
 * The automatic tour must never race the root redirect or cover an exact
 * entity link. When either happens, it waits until the person visits Home.
 */
export function shouldShowOnboarding({
  hydrated,
  initialSlug,
  workspaceSlug,
  activeView,
  currentUserId,
  currentUser,
  onboardingVersion,
  hasEntityDeepLink,
}: OnboardingEligibility) {
  if (!hydrated || !initialSlug || !workspaceSlug) return false;
  if (initialSlug !== workspaceSlug || activeView !== "home") return false;
  if (!currentUserId || !currentUser || currentUser.id !== currentUserId) {
    return false;
  }
  if (currentUser.isBot || hasEntityDeepLink) return false;
  return onboardingVersion < CURRENT_ONBOARDING_VERSION;
}

/**
 * Unlike Home's broader "needs you" queue, this is intentionally strict:
 * every item described as assigned belongs to the current person and is open.
 */
export function assignedOnboardingTasks(
  issues: Issue[],
  currentUserId: string | null
) {
  if (!currentUserId) return [];
  const assignedOpen = issues.filter(
    (issue) =>
      humanOwnerId(issue) === currentUserId &&
      issue.status !== "done" &&
      issue.status !== "canceled"
  );
  return relevantHomeTasks(assignedOpen, currentUserId);
}
